import { useTranslation } from 'react-i18next';

function UserCell({ user }) {
    const { id, first_name, last_name, } = user;
    const { t } = useTranslation('common');
    let fullName;

    if (first_name && last_name) {
        fullName = `${first_name} ${last_name}`;
    } else if (first_name) {
        fullName = first_name;
    } else if (last_name) {
        fullName = last_name;
    } else {
        fullName = t('users.roles.inventor') + ` #${id}`;
    }

    return (
        <div>
            <div>{fullName}</div>
        </div>
    );

}

export default UserCell;